import { toast } from 'react-toastify'
import { call, put } from 'redux-saga/effects'
import {
  getFulfillmentOperators,
  setError,
  setFulfillmentOperators,
  setLoading,
  setProcessing,
} from 'redux/slices/fulfillmentOperatorSlice'
import {
  requestCreateFulfillmentOperator,
  requestListFulfillmentOperators,
  requestUpdateFulfillmentOperatorStatus,
} from '../requests/fulfillmentOperatorService'

export function* handleGetFulfillmentOperators(action) {
  try {
    yield put(setLoading())
    const response = yield call(() =>
      requestListFulfillmentOperators(action.payload),
    )
    yield put(setFulfillmentOperators(response.data))
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    yield put(setError(errorMsg))
  }
}

export function* handleCreateFulfillmentOperator(action) {
  try {
    yield put(setProcessing(true))
    yield call(() => requestCreateFulfillmentOperator(action.payload))
    toast.success('Fulfillment operator created')
    yield put(getFulfillmentOperators({ page: 1, word: '' }))
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    toast.error(`Error: ${errorMsg}`)
  } finally {
    yield put(setProcessing(false))
  }
}

export function* handleUpdateFulfillmentOperatorStatus(action) {
  try {
    yield put(setProcessing(true))
    yield call(() =>
      requestUpdateFulfillmentOperatorStatus(
        action.payload.operatorId,
        action.payload.status,
      ),
    )
    toast.success('Fulfillment operator updated')
    yield put(getFulfillmentOperators({ page: 1, word: '' }))
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    toast.error(`Error: ${errorMsg}`)
  } finally {
    yield put(setProcessing(false))
  }
}
